import {Component, OnInit} from '@angular/core';
import {SharedService} from '../../services/shared.service';
import {CustomerService} from '../../services/customer.service';
import {CustomerModel} from '../../models/customer.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-sidenav',
  templateUrl: './user-sidenav.component.html',
  styleUrls: ['./user-sidenav.component.scss']
})
export class UserSidenavComponent implements OnInit {
  sideNavActive: boolean;
  menuItems: Array<MenuItem>;
  customer: CustomerModel;

  constructor(private shared: SharedService,
              private customerService: CustomerService,
              private router: Router) {
    this.shared.eventObservable
      .subscribe(event => {
        if (event.type == 'side_nav') {
          let timeOut = 50;
          if (this.sideNavActive) timeOut = 5;
          setTimeout(() => {
            this.sideNavActive = true;
          }, timeOut);
        }
        if (event.type == 'profile_refresh') {
          this.refreshCustomer();
        }
      });
    this.menuItems = [
      {
        name: 'Request',
        translate: 'REQUEST',
        icon: 'wahii-icon-request',
        route: '/account/request'
      },
      {
        name: 'Orders',
        translate: 'ORDERS',
        icon: 'wahii-icon-orders',
        route: '/account/orders'
      },
      {
        name: 'Payment',
        translate: 'PAYMENT',
        icon: 'wahii-icon-payment',
        route: '/account/payment'
      },
      {
        name: 'Promos',
        translate: 'PROMOS',
        icon: 'wahii-icon-promos',
        route: '/account/promos'
      }
    ];
  }

  ngOnInit() {
    this.refreshCustomer();
  }

  refreshCustomer() {
    this.customerService.getCurrentCustomer()
      .then(customer => {
        this.customer = customer;
      });
  }

  signOut() {
    return this.customerService.signOut()
      .then(() => {
        this.router.navigate(['/'])
          .then(() => {
            window.location.reload();
          });
      })
      .catch(_ => {
        this.router.navigate(['/'])
          .then(() => {
            window.location.reload();
          });
      });
  }

  clickOutSide() {
    setTimeout(() => {
      this.sideNavActive = false;
    }, 10);
  }

}

interface MenuItem {
  name: string,
  translate: string,
  icon: string,
  route: string
}
